import PRDIsInventory from "./prd-is-invertory";
import PRDAddToCart from "./prd-add-to-cart";
import PRDPrice from "./prd-price";
import {ProductsRelDocs} from "../../interfaces";
import PRDPriceNote from "./prd-price-note";
import {useAppSelector} from "../../data-services/store";
import {abtest_ProductListPricingAreaVariants} from "../../../../list-page/interfaces/interfaces";
interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    isGoogleShoppingFeed?: boolean,
}
/**
 * the entry point
 */
const ProductSingle= (props: IProductBuyButtonProps) => {

    const  product = props.product;
    const isProductNote = !product.skuEnabled && product.note !== null && product.note !== '';
    const abtest_ProductListPricingArea = useAppSelector((store) => store.abtest_ProductListPricingArea);
    return (

                <>
                    {isProductNote && <PRDPriceNote product={product}/>}

                    {!isProductNote && abtest_ProductListPricingArea !== abtest_ProductListPricingAreaVariants.perpetual_link && <PRDPrice product={product}/>}

                    {!isProductNote && <PRDAddToCart product={product} />}

                    {product.isInventory && <PRDIsInventory />}

                    {/*{productsRelDocsInitialSelected.includedInSBS > 0 && <ProductSBSTierNote product={product} />}*/}
                </>

    )
};

export default ProductSingle;